<template>
  <footer class="footer">
    <p
      class="footer-text"
      v-if="organizationDetails"
      v-translate="{ orgSupportEmail: organizationDetails.supportEmail }"
    >
      Reach out to %{orgSupportEmail} with any questions, issues, or feedback.
    </p>

    <div class="logo-wrapper-gc">
      <img class="logo" :src="require(`@/assets/images/${organizationDetails.canaryFooterLogo}`)" />
    </div>

  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: mapState(['organizationDetails']),
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/spinners';
@import '../styles/variables';
@import '@/styles/mixins/responsive';

.footer {
  background: black;
  height: $app-footer-height;
  margin-top: $app-footer-margin-top;
  position: relative;
  width: 100%;
  clear: both;
  bottom: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  max-height: $app-footer-height;
  min-height: $app-footer-height;

  @include tablet-and-up-screen {
    height: 224px;
    max-height: 224px;
    min-height: 224px;
  }
}

.footer-text {
  font-size: 1rem;
  color: $white;
  padding: 0 3rem;
  @media (max-width: $mobile-break-point) {
    font-size: 0.9rem;
  }
}

.logo-wrapper-gc {
  width: 100%;
  margin: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include tablet-and-up-screen {
    height: 3.5rem;
  }
}

.logo {
  max-width: 250px;
}
</style>
